// extracted by mini-css-extract-plugin
export default {"tabsAutoWidth":"IntegrationAPI_tabsAutoWidth__Mrpiz"};